import React, { useMemo } from 'react';
import { Grid } from '@mui/material';
import { SummedReport, BreakdownReport } from '../../../models/ReportData';
import { AdminTierTypeEnum } from '../../../services/drillDown';
import ReportBreakdown from './ReportBreakdown';
import EmptyReport from '../EmptyReport';
import UserAccountsTable from './UserAccountsTable';
import {
  buildAccountsTable,
  getVisibleColumnTypes,
  buildUserAccountSections,
} from '../../../data/report/helpers/userAccountsUtils';
import { getSectionHelpContent } from './SectionHeader';

interface ReportUserAccountsProps {
  summedReport: SummedReport | null;
  breakdownReport: BreakdownReport | null;
  tier: AdminTierTypeEnum | undefined;
}

const ReportUserAccounts: React.FC<ReportUserAccountsProps> = ({
  summedReport,
  breakdownReport,
  tier,
}) => {
  const displayReport = summedReport;

  const data = useMemo(() => {
    if (!displayReport) {
      return {};
    }
    return buildAccountsTable(displayReport);
  }, [displayReport]);

  const isEmpty = useMemo(() => {
    return Object.keys(data).length === 0;
  }, [data]);

  const columns = useMemo(() => {
    return getVisibleColumnTypes(data);
  }, [data]);

  const sections = useMemo(() => {
    const baseSections = buildUserAccountSections(data);
    return baseSections.map(section => ({
      ...section,
      helpContent: getSectionHelpContent(section.label),
    }));
  }, [data]);

  if (!summedReport || isEmpty) {
    return <EmptyReport />;
  }

  return (
    <Grid>
      <UserAccountsTable data={data} columns={columns} sections={sections} />
      {breakdownReport && (
        <ReportBreakdown tier={tier} breakdownReport={breakdownReport} isEmpty={isEmpty} />
      )}
    </Grid>
  );
};

export default ReportUserAccounts;
